import React, { useEffect, useCallback } from 'react';
import zxcvbn from 'zxcvbn';

function PasswordIndicator({ password, passLabelColor }) {
  const passwordString = String(password || '');
  const result = zxcvbn(passwordString);
  const num = (result.score * 100) / 4;

  const progressColor = useCallback(() => {
    switch (result.score) {
      case 0:
        return '#828282';
      case 1:
        return '#EA1111';
      case 2:
        return '#FFAD00';
      case 3:
        return '#9bc158';
      case 4:
        return '#00b500';
      default:
        return 'none';
    }
  }, [result.score]);

  const passLabel = useCallback(() => {
    switch (result.score) {
      case 0:
        return 'Very Weak';
      case 1:
        return 'Weak';
      case 2:
        return 'Fair';
      case 3:
        return 'Good';
      case 4:
        return 'Strong';
      default:
        return 'none';
    }
  }, [result.score]);

  useEffect(() => {
    const debounce = setTimeout(() => {
      passLabelColor(passLabel(), progressColor());
    }, 300); // 300ms debounce

    return () => clearTimeout(debounce);
  }, [password, passLabel, progressColor, passLabelColor]);

  const handleChangeColor = {
    width: `${num}%`,
    height: '.1rem',
    background: progressColor(),
  };

  return (
    <div className="PasswordIndicatorContainer">
      <div className="progress" style={{ height: 'max-content' }}>
        <div className="progress-bar" style={handleChangeColor}></div>
      </div>
    </div>
  );
}

export default PasswordIndicator;
